import React, { Component } from 'react'
import { Icon } from 'semantic-ui-react'

export default class Projects extends Component {
  render() {
    return (
      <div className="section">
        <p className="title"><Icon name="file code" />Projects</p>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Projects.js